import { Badge } from "@mantine/core";

import { priorityLabel } from "../../lib/customerView/priorityLabel.js";

/** Prioritätsfarbe nach führender Ziffer („1" = höchste → rot). */
function color(name: string): string {
  switch (name.trim().charAt(0)) {
    case "1": return "red";
    case "2": return "orange";
    case "3": return "yellow";
    default: return "gray";
  }
}

export function PriorityChip({ name }: { name?: string | null }) {
  if (!name) return null;
  return (
    <Badge variant="outline" color={color(name)} size="xs" radius="sm" style={{ textTransform: "none" }}>
      {priorityLabel(name)}
    </Badge>
  );
}
